import { apiClient, API_CONFIG } from '../../core';
import type { ApiResponse } from '../../shared';
import type { LC_MenuItemOut, MenuItem } from './menu.types';
import { mapMenuOutToModel, splitConfigMenuIfNeeded } from './menu.mapper';


export class MenuService {
  async list(): Promise<ApiResponse<LC_MenuItemOut[]>> {
    const res = await apiClient.get<LC_MenuItemOut[]>(API_CONFIG.ENDPOINTS.MENU);
    if (!res.success && res.error && (res.error.code === 'TIMEOUT' || res.error.code === 'NETWORK_ERROR')) {
      // simple one-shot retry for transient errors
      return apiClient.get<LC_MenuItemOut[]>(API_CONFIG.ENDPOINTS.MENU);
    }
    return res;
  }

  toModel(dto: LC_MenuItemOut): MenuItem { return mapMenuOutToModel(dto); }
  split(items: MenuItem[]) { return splitConfigMenuIfNeeded(items); }
}

export const menuService = new MenuService();
